import { Switch } from "@headlessui/react";
import ManifestDropdown from "../manifest/manifestsDropdowns";
import DataSetDropdown from "../dataSet/dataSetDropdowns";
import { FaChevronUp, FaChevronDown } from "react-icons/fa6";

const AdvancedFiltersGroup = ({
    rawValues,
    queryParams,
    handleManifestSelection,
    handleDataSetSelection,
    handleRegexToggleChange,
    areAdvancedFiltersToggled,
    toggleAdvancedFilters,
    showManifestFilter = true,
    showDataSetFilter = true,
    showRegexFilter = true
}: {
    rawValues: any;
    queryParams: any;
    handleManifestSelection: (option: any) => void;
    handleDataSetSelection: (option: any) => void;
    handleRegexToggleChange: (value: boolean) => void;
    areAdvancedFiltersToggled: boolean;
    toggleAdvancedFilters: () => void;
    showManifestFilter?: boolean;
    showDataSetFilter?: boolean;
    showRegexFilter?: boolean;
}) => {
    const hasAnyFilter = showManifestFilter || showDataSetFilter || showRegexFilter;

    if (!hasAnyFilter) return null;

    return (
        <div className="col-span-10 col-start-2 mb-3 mt-2">
            <div
                className="flex w-full cursor-pointer items-center justify-between"
                onClick={toggleAdvancedFilters}
            >
                <p className="text-lg text-blue-200">Advanced</p>
                {areAdvancedFiltersToggled ? (
                    <FaChevronUp size={16} />
                ) : (
                    <FaChevronDown size={16} />
                )}
            </div>
            <div
                style={{
                    maxHeight: areAdvancedFiltersToggled ? "200px" : "0",
                    transition: "max-height 0.2s ease-in-out",
                }}
                className={`mb-3 mt-2 flex w-full space-x-4 ${areAdvancedFiltersToggled ? "" : "overflow-hidden"
                    }`}
            >
                {showManifestFilter && (
                    <ManifestDropdown
                        selections={rawValues.manifestPublicIds}
                        onOptionToggle={handleManifestSelection}
                        className="w-[14rem]"
                    />
                )}
                {showDataSetFilter && (
                    <DataSetDropdown
                        selections={rawValues.dataSetPublicIds}
                        onOptionToggle={handleDataSetSelection}
                        className="w-[10.125rem]"
                    />
                )}
                {showRegexFilter && (
                    <div className="h-full">
                        <label className="flex items-center">
                            <span className="mr-2 mt-2 h-full">Regex</span>
                            <Switch
                                checked={queryParams.regex}
                                onChange={handleRegexToggleChange}
                                className={`${queryParams.regex ? "bg-blue-200" : "bg-gray-200"
                                    }
                  relative mt-2 inline-flex h-full w-11 items-center
                  rounded-full p-[3px] transition-colors duration-200 ease-in-out`}
                            >
                                <span
                                    className={`${queryParams.regex
                                        ? "translate-x-[1.375rem]"
                                        : "translate-x-0"
                                        }
                inline-block h-4 w-4 transform rounded-full bg-white
                transition-transform duration-200 ease-in-out`}
                                />
                            </Switch>
                        </label>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdvancedFiltersGroup;